// extracted by mini-css-extract-plugin
module.exports = {"backgroundImage":"UpgradeToWatch_backgroundImage__14TKf","title":"UpgradeToWatch_title__2HRpo"};